export default "__VITE_ASSET__DBJ3xqCX__"